import { render, staticRenderFns } from "./card-escalate.vue?vue&type=template&id=563b2baa&scoped=true"
import script from "./card-escalate.vue?vue&type=script&lang=js"
export * from "./card-escalate.vue?vue&type=script&lang=js"
import style0 from "./card-escalate.vue?vue&type=style&index=0&id=563b2baa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563b2baa",
  null
  
)

export default component.exports